// import 'babel-polyfill';
import { LANGUAGE_CHANGE } from '@axa-asia/hk-shared-utils/lib/languageReducer';
import { setGoto, useGoto } from '@axa-asia/utils';
import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module';
import { trackFirstScreen } from './utils/analytics';
import { IndexRoute, Route, Router } from 'react-router';
import config from './config';
import { browserHistoryGoto } from './utils/common-functions';
import { renderRouteNode } from './utils/renderRouteNode';

import {
  ROUTE_FIND_MY_POLICY,
  ROUTE_FORGET_PASSWORD,
  ROUTE_FORGET_USERNAME,
  ROUTE_FORGOT,
  ROUTE_IAM_ERROR,
  ROUTE_REGISTRATION,
} from './routeConfig';

import { loadWithSpinner } from './utils/loadWithSpinner';

export default function routes({ history, dispatch }) {
  const [isInit, setIsInit] = useState(false);

  function initLang(route) {
    if (route.params.lang.indexOf('.') === -1) {
      const lang = route.params.lang;
      document.documentElement.lang = lang;
    }
  }

  function changeLanguage(route) {
    // relative paths will use .
    if (route.params.lang.indexOf('.') === -1) {
      dispatch({
        type: LANGUAGE_CHANGE,
        language: route.params.lang,
      });
    }
  }

  function handleRootRouteEnter(nextState) {
    initLang(nextState);
    changeLanguage(nextState);
    const tagManagerArgs = {
      gtmId: config.googleTagManagerID,
    };

    TagManager.initialize(tagManagerArgs);
    ReactGA.initialize(config.googleAnalyticsId);
    ReactGA.pageview(nextState.location.pathname);
    trackFirstScreen();
  }

  function handleRootRouteChange(prevState, nextState) {
    if (prevState.location !== nextState.location) {
      window.scrollTo(0, 0);
    }
    //   sendVirtualPageEvent(getVirtualPageParams(nextState.location.pathname, nextState.params));
  }

  const iamFeRoutes = (
    <Route
      path={`:lang/${config.webview.identityFEPath}`}
      onEnter={handleRootRouteEnter}
      onChange={handleRootRouteChange}
    >
      <Route
        path="emma"
        getComponent={(nextState, cb) => {
          loadWithSpinner(() => import('./containers/emmaContainer'), cb);
        }}
      >
        {renderRouteNode(ROUTE_FORGET_PASSWORD)} 
        {renderRouteNode(ROUTE_REGISTRATION)}
        {renderRouteNode(ROUTE_FORGET_USERNAME)} 
        {renderRouteNode(ROUTE_IAM_ERROR)} 



        <Route
          path="invalid-link"
          getComponent={(nextState, cb) => {
            loadWithSpinner(
              () => import('./containers/invalidLinkContainer'),
              cb,
            );
          }}
        />
        <Route
          path="login"
          getComponent={(nextState, cb) => {
            loadWithSpinner(
              () => import('./containers/Login/LoginContainer_v2'),
              cb,
            );
          }}
        />
        <Route
          path="login-fail/:errorCode"
          getComponent={(nextState, cb) => {
            loadWithSpinner(
              () => import('./containers/Login/LoginFailureContainer_v2'),
              cb,
            );
          }}
        />
        {/* <Route
          path="loginSuccess"
          getComponent={(nextState, cb) => {
            import('./containers/Login/LoginSuccessContainer_v2').then(component => cb(null, component.default));
          }}
        /> */}
        <Route
          path="terms-and-conditions/:token"
          getComponent={(nextState, cb) => {
            loadWithSpinner(
              () => import('./containers/Login/TermsAndConditions_v2'),
              cb,
            );
          }}
        />
        {renderRouteNode(ROUTE_FIND_MY_POLICY)}

        <Route
          path="policy"
          getComponent={(nextState, cb) => {
            loadWithSpinner(() => import('./containers/emmaContainer'), cb);
          }}
        >
          <Route
            path="link/success"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () =>
                  import('./containers/FindMyPolicy/FindPolicyOtpSuccess_v2'),
                cb,
              );
            }}
          />
          <Route
            path="link/activated"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () =>
                  import('./containers/FindMyPolicy/FindPolicyOtpActivated_v2'),
                cb,
              );
            }}
          />
          <Route
            path="link/fail"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/FindMyPolicy/FindPolicyOtpFail_v2'),
                cb,
              );
            }}
          />
          <Route
            path="link/invalidUser"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () =>
                  import('./containers/FindMyPolicy/FindPolicyOtpInvalid_v2'),
                cb,
              );
            }}
          />
          <Route
            path="link/tokenExpired"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () =>
                  import('./containers/FindMyPolicy/FindPolicyOtpExpired_v2'),
                cb,
              );
            }}
          />
          <Route
            path="link/invalidToken"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () =>
                  import(
                    './containers/FindMyPolicy/FindPolicyOtpInvalidToken_v2'
                  ),
                cb,
              );
            }}
          />
        </Route>

        <Route
          path="customer-support"
          getComponent={(nextState, cb) => {
            loadWithSpinner(
              () => import('./containers/CustomerSupport/CustomerSupport'),
              cb,
            );
          }}
        />
        <Route
          path="review-information"
          getComponent={(nextState, cb) => {
            loadWithSpinner(
              () => import('./containers/ReviewInfoContainer'),
              cb,
            );
          }}
        />
      </Route>
      {/** Deprecated route */}
      {/* <Route
        path="loginsuccess"
        getComponent={(nextState, cb) => {
          loadWithSpinner(() => import('./containers/Login/LoginSuccessContainer'), cb)
        }}
      /> */}
      <Route
        getComponent={(nextState, cb) => {
          loadWithSpinner(() => import('./containers/AppContainer'), cb);
        }}
      >
        <Route
          path="login"
          getComponent={(nextState, cb) => {
            loadWithSpinner(
              () => import('./containers/Login/LoginContainer'),
              cb,
            );
          }}
        />
        <Route
          path="registration"
          getComponent={(nextState, cb) => {
            loadWithSpinner(() => import('./containers/SignUpContainer'), cb);
          }}
        >
          <IndexRoute
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpPolicyTypeSelection'),
                cb,
              );
            }}
          />
          <Route
            path="individual-policy"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () =>
                  import('./containers/SignUp/SignUpIndividualPolicySelection'),
                cb,
              );
            }}
          />
          <Route
            path="company-policy-selection"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () =>
                  import('./containers/SignUp/SignUpCompanyPolicySelection'),
                cb,
              );
            }}
          />
          <Route
            path="axa-card-selected"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpAxaCardSelected'),
                cb,
              );
            }}
          />
          <Route
            path="axa-cn"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpAxaCardCN'),
                cb,
              );
            }}
          />
          <Route
            path="other-card-selected"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpOtherCardSelected'),
                cb,
              );
            }}
          />
          <Route
            path="create-account"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpCreateAccount'),
                cb,
              );
            }}
          />
          <Route
            path="create-account-fail"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpCreateAccountFail'),
                cb,
              );
            }}
          />
          <Route
            path="activation/success"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpActivationSuccess'),
                cb,
              );
            }}
          />
          <Route
            path="activation/fail"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpActivationFail'),
                cb,
              );
            }}
          />
          <Route
            path="username-used"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpUsernameUsed'),
                cb,
              );
            }}
          />
          <Route
            path="username-registered"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpUsernameRegistered'),
                cb,
              );
            }}
          />
          <Route
            path="create-password"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpCreatePassword'),
                cb,
              );
            }}
          />
          <Route
            path="create-password-success"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpCreatePasswordSuccess'),
                cb,
              );
            }}
          />
          <Route
            path="terms-and-conditions/:token"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/TermsAndConditions'),
                cb,
              );
            }}
          />
          <Route
            path="life/create-account"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpCreateLifeAccount'),
                cb,
              );
            }}
          />
          <Route
            path="life/dob"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpLifeDob'),
                cb,
              );
            }}
          />
          <Route
            path="eb/dob"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpEBDob'),
                cb,
              );
            }}
          />
          <Route
            path="contact-us"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpContactUs'),
                cb,
              );
            }}
          />
          <Route
            path="submit-enquiry"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpSubmitEnquiry'),
                cb,
              );
            }}
          />
          <Route
            path="submit-enquiry-success"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpSubmitEnquirySuccess'),
                cb,
              );
            }}
          />
          <Route
            path="hkid-selected"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpHKIdSelected'),
                cb,
              );
            }}
          />
          <Route
            path="chinaId-selected"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpChinaIdSelected'),
                cb,
              );
            }}
          />
          <Route
            path="passport-selected"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpPassportSelected'),
                cb,
              );
            }}
          />
          <Route
            path="life/resend"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpResendLifeLinkSuccess'),
                cb,
              );
            }}
          />
          <Route
            path="resend"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/SignUp/SignUpResendLinkSuccess'),
                cb,
              );
            }}
          />
        </Route>
      </Route>
      <Route
        path="expired"
        getComponent={(nextState, cb) => {
          loadWithSpinner(
            () => import('./components/ExpiredPage/ExpiredPage'),
            cb,
          );
        }}
      />
      <Route
        path="*"
        getComponent={(nextState, cb) => {
          loadWithSpinner(() => import('./containers/AppContainer'), cb);
        }}
      >
        <IndexRoute
          getComponent={(nextState, cb) => {
            loadWithSpinner(() => import('./components/NotFound/NotFound'), cb);
          }}
        />
      </Route>
    </Route>
  );

  useGoto(); // Need to mount first b4 init
  useEffect(() => {
    setGoto(browserHistoryGoto, () => {
      setIsInit(true);
    });
  }, []);

  if (!isInit) return null;
  return (
    <Router history={history}>
      {iamFeRoutes}
      <Route
        path={`:lang/emma`}
        onEnter={handleRootRouteEnter}
        onChange={handleRootRouteChange}
      >
        <Route
          path={'legal'}
          getComponent={(nextState, cb) => {
            loadWithSpinner(() => import('./containers/emmaContainer'), cb);
          }}
        >
          <Route
            path="privacy-policy"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/Login/TermsAndConditions_v2'),
                cb,
              );
            }}
          />
          <Route
            path="terms-and-conditions"
            getComponent={(nextState, cb) => {
              loadWithSpinner(
                () => import('./containers/Login/TermsAndConditions_v2'),
                cb,
              );
            }}
          />
        </Route>
      </Route>
    </Router>
  );
}
